export class ApiError extends Error {
  status: number;
  data: Record<string, unknown>;
  constructor(status: number, data: Record<string, unknown>) {
    super(String(data.error || "Не удалось выполнить запрос."));
    this.status = status;
    this.data = data;
  }
}
export async function api<T>(
  path: string,
  options: RequestInit = {},
): Promise<T> {
  const form = options.body instanceof FormData;
  let response: Response;
  try {
    response = await fetch("/api" + path, {
      ...options,
      headers: {
        ...(!form && options.body
          ? { "Content-Type": "application/json" }
          : {}),
        ...options.headers,
      },
    });
  } catch (e) {
    if ((e as Error).name === "AbortError") throw e;
    throw new Error(
      "Нет связи с сервером. Проверь подключение и повтори попытку.",
    );
  }
  let data: Record<string, unknown>;
  try {
    data = await response.json();
  } catch {
    throw new ApiError(response.status, {
      error: "Сервер временно недоступен. Повтори попытку позже.",
    });
  }
  if (!response.ok) throw new ApiError(response.status, data);
  return data as T;
}
export const json = (method: string, data: unknown): RequestInit => ({
  method,
  body: JSON.stringify(data),
});
export function download(
  filename: string,
  content: string,
  type = "text/plain;charset=utf-8",
) {
  const url = URL.createObjectURL(new Blob([content], { type }));
  const link = document.createElement("a");
  link.href = url;
  link.download = filename;
  link.click();
  setTimeout(() => URL.revokeObjectURL(url), 1000);
}
